import './MobileOnlyMessage.css';

import { useTranslation } from 'react-i18next';

import Logo from '../../images/CHNewDarkLogo.svg';
import QrCard1 from '../../images/qrCard1.png';
import QrCard2 from '../../images/qrCard2.png';
import { useUserData } from '../../shared/hooks/useUserData';

export function MobileOnlyMessage() {
  const { t } = useTranslation();
  const { userData } = useUserData();

  return (
    <main id="main_container" className="mobile-only-page">
      <section className="mobile-only-message">
        <img
          src={Logo}
          alt={t('assessment.mobileOnly.logoAlt')}
          className="mobile-only-message__logo"
        />
        <h1 className="mobile-only-message__greeting">
          {t('assessment.mobileOnly.greeting', { name: userData.fname })}
        </h1>
        <p className="mobile-only-message__description">{t('assessment.mobileOnly.description')}</p>
        <p className="mobile-only-message__scan">{t('assessment.mobileOnly.scan')}</p>
        <div className="mobile-only-message__qr-cards">
          <img src={QrCard1} alt={t('assessment.mobileOnly.qrAppStore')} />
          <img src={QrCard2} alt={t('assessment.mobileOnly.qrGooglePlay')} />
        </div>
      </section>
      <footer className="mobile-only-message__footer">
        <p>{t('assessment.mobileOnly.contactAdmin')}</p>
      </footer>
    </main>
  );
}
